"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query organizations(
    $query: OrganizationQueryInput
    $pagination: PaginationInput
  ) {
    organizations(query: $query, pagination: $pagination) {
      _id
      orgName
      orgUrls
      orgLogoUrl
      createdAt
      isOrgDeletable
      address {
        address1
        address2
        city
        state
        zip
        country
        placeName
      }
      user {
        email
      }
      seating {
        publicKey
        secretKey
        designerKey
      }
      webFlow {
        sites {
          name
          webFlowId
          enabled
          createdAt
          updatedAt
          previewUrl
          domains {
            lastPublishedAt
            name
          }
        }
      }
    }
  }
`;
exports.default = query;
//# sourceMappingURL=organizations.query.js.map